import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container, Box } from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import Header from './components/Header';
import DataTable from './pages/DataTable';
import Donate from './pages/Donate';
import Tools from './pages/Tools';
import Feedback from './pages/Feedback';
import FeedbackView from './pages/FeedbackView';
import ScrollToTop from './components/ScrollToTop';
import HelmetProvider from './components/HelmetProvider';
import SEOHead from './components/SEOHead';
import BaiduAnalytics from './components/BaiduAnalytics';
import StructuredData from './components/StructuredData';
import { useTheme } from './contexts/ThemeContext';
import { getTheme } from './theme';

function App() {
  const { themeMode } = useTheme();
  const currentTheme = getTheme(themeMode);

  return (
    <HelmetProvider>
      <MuiThemeProvider theme={currentTheme}>
        <Router>
          <SEOHead />
          <BaiduAnalytics />
          <StructuredData />
          <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: 'background.default', color: 'text.primary' }}>
            <Header />
            <Container maxWidth="xl" sx={{ mt: 4, mb: 4, flex: 1 }}>
              <Routes>
                <Route path="/" element={<DataTable />} />
                <Route path="/longhubang" element={<DataTable />} />
                <Route path="/donate" element={<Donate />} />
                <Route path="/tools" element={<Tools />} />
                <Route path="/feedback" element={<Feedback />} />
                <Route path="/feedback/view" element={<FeedbackView />} />
              </Routes>
            </Container>
            <ScrollToTop />
          </Box>
        </Router>
      </MuiThemeProvider>
    </HelmetProvider>
  );
}

export default App;